<div
  #modalContents
  [class]="lmodalContentsClassWithWidth"
  aria-modal="true"
  role="dialog"
  aria-labelledby="plan-review-agreement-kr-modal-title"
>
  <div #modalHead [class]="lmodalHeaderClass">
    <div class="p-modal-head01">
      <h1
        id="plan-review-agreement-kr-modal-title"
        class="p-modal-head01__title"
        [innerHTML]="'heading.agreement' | staticMsg"
      ></h1>
      <button id="close-kr-modal" class="p-modal-head01__close js-modal-close" (click)="clickClose()">
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
  </div>

  <div #modalBody [class]="lmodalBodyClass">
    <div class="p-modal-body01">
      <p class="c-text-m c-text-m--bold" [innerHTML]="'label.agreementGuidanceWithPluralCheckboxes' | staticMsg"></p>
      <div class="p-modal-body01__checkbox">
        <asw-checkbox-group direction="vertical">
          <asw-checkbox
            id="plan-review-agreement-kr-modal-chkbox-1"
            [label]="'rule.collectionAndUsePersonalInformation' | staticMsg"
            [formControl]="agreementFC_1"
            required
          ></asw-checkbox>
          <asw-checkbox
            id="plan-review-agreement-kr-modal-chkbox-2"
            [label]="'rule.disclosureToThirdParty' | staticMsg"
            [formControl]="agreementFC_2"
            required
          ></asw-checkbox>
          <asw-checkbox
            id="plan-review-agreement-kr-modal-chkbox-3"
            [label]="'rule.businessEntrustmentToThirdParty' | staticMsg"
            [formControl]="agreementFC_3"
            required
          ></asw-checkbox>
        </asw-checkbox-group>
      </div>
    </div>
  </div>

  <div #modalFooter [class]="lmodalFooterClass">
    <div class="p-modal-foot02">
      <div></div>
      <asw-button
        id="plan-review-agreement-kr-modal-agreement-btn"
        disabled="{{ !(agreementFC_1.value && agreementFC_2.value && agreementFC_3.value) }}"
        (click$)="clickContinue()"
        [label]="'label.continue2' | staticMsg"
      ></asw-button>
    </div>
  </div>
</div>
